const getSelectPartner = () => {
  const selectPartner = localStorage.getItem("selectPartner")
    ? JSON.parse(localStorage.getItem("selectPartner"))
    : null;
  return selectPartner;
};

const InitialState = {
  selectPartner: getSelectPartner(),
};

const SelectedPartnerReducer = (state = InitialState, action) => {
  if (action.type === "Select_Partner") {
    const newState = {
      selectPartner: action.payload,
    };

    localStorage.setItem("selectPartner", JSON.stringify(action.payload));

    return newState;
  }

  //logout
  else if (action.type === "Remove_User") {
    const newState = {
      selectPartner: null,
    };

    localStorage.removeItem("selectPartner");
    return newState;
  }

  return state;
};

export default SelectedPartnerReducer;
